import { createSlice } from "@reduxjs/toolkit";

export const counterSlice = createSlice({
  name: "tickets",

  initialState: [
    {
      date: "19/04/2011",
      acts: ["Underoath", "Deaf Havana", "Devil Sold His Soul"],
      venue: { name: "KOKO, London", id: "koko" },
    },
    {
      date: "30/09/2011",
      acts: [
        "A Skylit Drive",
        "Sleeping With Sirens",
        "Woe, Is Me",
        "I Set My Friends On Fire",
      ],
      venue: { name: "O2 Academy, Birmingham", id: "o2-academy-birmingham" },
    },
    {
      date: "15/10/2011",
      acts: ["Enter Shikari", "Letlive", "Your Demise"],
      venue: { name: "O2 Academy, Birmingham", id: "o2-academy-birmingham" },
    },
    {
      date: "17/12/2011",
      acts: ["Architects", "Heights", "Deaf Havana", "Tek-One"],
      venue: { name: "HMV Institute, Birmingham", id: "hmv" },
    },
    {
      date: "18/03/2012",
      acts: [
        "Yashin",
        "Tantrum to Blind",
        "Jody Has A Hitlist",
        "With One Last Breath",
      ],
      venue: { name: "O2 Academy, Birmingham", id: "o2-academy-birmingham" },
    },
    {
      date: "20/03/2012",
      acts: ["Enter Shikari", "Young Guns", "Tek-One"],
      venue: { name: "Civic Hall, Wolverhampton", id: "civic-hall" },
    },
    {
      date: "20/04/2012",
      acts: ["Twin Atlantic", "Lower Than Atlantis", "ME"],
      venue: { name: "Wulfrun Hall, Wolverhampton", id: "civic-hall" },
    },
    {
      date: "30/04/2012",
      acts: [
        "Of Mice & Men",
        "Bury Tomorrow",
        "With One Last Breath",
        "Crossfaith",
      ],
      venue: { name: "Kasbah, Coventry", id: "kasbah" },
    },
    {
      date: "22/09/2012",
      acts: ["Pierce The Veil", "Crown The Empire", "The Getaway Plan"],
      venue: { name: "The Asylum, Birmingham", id: "asylum" },
    },
    {
      date: "10/10/2012",
      acts: ["Mayday Parade", "The Summer Set", "The Natives", "For The Foxes"],
      venue: { name: "HMV Institute, Birmingham", id: "hmv" },
    },
    {
      date: "08/11/2012",
      acts: ["Deaf Havana", "There For Tomorrow", "Canterbury"],
      venue: { name: "Kasbah, Coventry", id: "kasbah" },
    },
    {
      date: "15/12/2012",
      acts: ["Enter Shikari", "Cancer Bats", "Engine-Earz Experiment"],
      venue: { name: "HMV Institute, Birmingham", id: "hmv" },
    },
    {
      date: "06/01/2013",
      acts: ["Ron Pope", "To Kill A King", "Saul Ashby"],
      venue: { name: "Glee Club, Birmingham", id: "glee-club" },
    },
    {
      date: "05/05/2013",
      acts: ["Enter Shikari", "Hacktivist", "Baby Godzilla"],
      venue: { name: "Kasbah, Coventry", id: "kasbah" },
    },
    {
      date: "30/05/2013",
      acts: ["Pierce The Veil", "Woe, Is Me", "Hands Like Houses"],
      venue: { name: "The Sugarmill, Stoke-on-Trent", id: "sugarmill" },
    },
    {
      date: "05/12/2013",
      acts: ["Avenged Sevenfold", "Five Finger Death Punch", "Avatar"],
      venue: { name: "LG Arena, Birmingham", id: "lg-arena" },
    },
    {
      date: "27/01/2015",
      acts: ["Slipknot", "KoRn", "King 810"],
      venue: { name: "Barclaycard Arena, Birmingham", id: "barclaycard" },
    },
    {
      date: "23/02/2016",
      acts: ["Twenty One Pilots", "Transviolet"],
      venue: { name: "O2 Academy, Birmingham", id: "o2-academy-birmingham" },
    },
    {
      date: "10-11/12/2016",
      acts: ["Red Hot Chili Peppers", "BABYMETAL"],
      venue: { name: "Genting Arena, Birmingham", id: "genting" },
    },
    {
      date: "07/07/2017",
      acts: ["Blink-182", "Frank Turner", "The Front Bottoms"],
      venue: { name: "Barclaycard Arena, Birmingham", id: "barclaycard" },
    },
    {
      date: "23/09/2017",
      acts: ["Mayday Parade"],
      venue: {
        name: "O2 Institute, Birmingham",
        id: "o2-institute-birmingham",
      },
    },
    {
      date: "22/02/2018",
      acts: ["King Gizzard and the Lizard Wizard", "Mild High Club"],
      venue: { name: "Manchester Academy, Manchester", id: "manc-academy" },
    },
    {
      date: "26/02/2018",
      acts: ["The Front Bottoms", "The Smith Street Band", "Brick + Mortar"],
      venue: {
        name: "O2 Institute, Birmingham",
        id: "o2-institute-birmingham",
      },
    },
    {
      date: "17/09/2018",
      acts: ["Psychedelic Porn Crumpets", "Moon Panda"],
      venue: {
        name: "The Sunflower Lounge, Birmingham",
        id: "sunflower-lounge",
      },
    },
    {
      date: "11/02/2019",
      acts: ["The Murlocs", "Night Beats"],
      venue: {
        name: "The Hare & Hounds, Birmingham",
        id: "hare-and-hounds",
      },
    },
    {
      date: "25/02/2019",
      acts: ["Psychedelic Porn Crumpets", "The Mysterines"],
      venue: { name: "The Bullingdon, Oxford", id: "bullingdon" },
    },
    {
      date: "28/02/2019",
      acts: ["Only The Poets"],
      venue: { name: "O2 Academy, Birmingham", id: "o2-academy-birmingham" },
    },
    {
      date: "26/03/2019",
      acts: ["Panic! At The Disco", "Arizona", "Mø"],
      venue: { name: "Utilita Arena, Birmingham", id: "utilita-arena" },
    },
    {
      date: "29/03/2019",
      acts: ["Watsky", "Feed The Biirds"],
      venue: {
        name: "O2 Institute, Birmingham",
        id: "o2-institute-birmingham",
      },
    },
    {
      date: "04/05/2019",
      acts: ["Catfish and the Bottlemen", "Twin Atlantic"],
      venue: { name: "Ricoh Arena, Coventry", id: "ricoh-arena" },
    },
    {
      date: "05/10/2019",
      acts: ["King Gizzard and the Lizard Wizard", "Stonefield", "ORB"],
      venue: { name: "Alexandra Palace, London", id: "ally-pally" },
    },
    {
      date: "18/10/2019",
      acts: ["Psychedelic Porn Crumpets", "Crows"],
      venue: {
        name: "The Castle & Falcon, Birmingham",
        id: "castle-and-falcon",
      },
    },
    {
      date: "08/11/2019",
      acts: ["Marc Rebillet"],
      venue: { name: "Marble Factory, Bristol", id: "marble-factory" },
    },
    {
      date: "11/12/2019",
      acts: ["The Chats", "Bad Dreems", "Crocodylus"],
      venue: {
        name: "O2 Institute, Birmingham",
        id: "o2-institute-birmingham",
      },
    },
    {
      date: "03/03/2020",
      acts: ["Marika Hackman", "The Hackstreet Boys", "Talk Show"],
      venue: { name: "Mama Roux’s, Birmingham", id: "mama-roux" },
    },
    {
      date: "10/10/2020",
      acts: ["Only The Poets"],
      venue: { name: "Also Known As, Banbury", id: "aka" },
    },
    {
      date: "10/11/2021",
      acts: ["Glass Animals", "Biig Piig"],
      venue: { name: "O2 Academy, Birmingham", id: "o2-academy-birmingham" },
    },
    {
      date: "22/01/2022",
      acts: ["IDLES", "Big Joanie", "Jehnny Beth"],
      venue: { name: "O2 Academy, Birmingham", id: "o2-academy-birmingham" },
    },
    {
      date: "16/02/2022",
      acts: ["Sad Night Dynamite", "Mac Wetha"],
      venue: { name: "Rainbow, Birmingham", id: "rainbow-pub" },
    },
    {
      date: "03/04/2022",
      acts: ["Thundercat", "Unknown P", "Miso Extra"],
      venue: { name: "O2 Academy, Brixton", id: "o2-academy-brixton" },
    },
    {
      date: "19/05/2022",
      acts: ["My Chemical Romance", "Placebo", "LostAlone", "Witch Fever"],
      venue: { name: "Stadium MK, Milton Keynes", id: "stadium-mk" },
    },
    {
      date: "26/08/2022",
      acts: ["Psychedelic Porn Crumpets", "Home Counties"],
      venue: {
        name: "O2 Institute, Birmingham",
        id: "o2-institute-birmingham",
      },
    },
    {
      date: "04/10/2022",
      acts: ["Machine Gun Kelly", "Iann Dior", "44phantom"],
      venue: { name: "Utilita Arena, Birmingham", id: "utilita-arena" },
    },
    {
      date: "21/10/2022",
      acts: ["Sad Night Dynamite", "Jeshi"],
      venue: { name: "Canvas", id: "canvas-manchester" },
    },
    {
      date: "03/11/2022",
      acts: ["Joywave", "George O'Hanlon"],
      venue: { name: "The Deaf Institute, Manchester", id: "deaf-institute" },
    },
    {
      date: "23/03/2023",
      acts: ["King Gizzard and the Lizard Wizard", "Los Bitchos"],
      venue: { name: "Troxy, London", id: "troxy-london" },
    },
    {
      date: "22/04/2023",
      acts: ["Paramore", "Bloc Party"],
      venue: { name: "Utilita Arena, Birmingham", id: "utilita-arena" },
    },
    {
      date: "24/05/2023",
      acts: ["The Chats", "The Chisel", "Quantanamo Baywatch"],
      venue: {
        name: "O2 Institute, Birmingham",
        id: "o2-institute-birmingham",
      },
    },
    {
      date: "24/05/2023",
      acts: ["Psychedelic Porn Crumpets"],
      venue: {
        name: "O2 Institute, Birmingham",
        id: "o2-institute-birmingham",
      },
    },
    {
      date: "16/06/2023",
      acts: ["Tenacious D", "Steel Beans"],
      venue: {
        name: "O2 Arena, London",
        id: "o2-arena-london",
      },
    },
    {
      date: "21/02/2024",
      acts: ["Psychedelic Porn Crumpets", "Feet"],
      venue: { name: "O2 Academy, Birmingham", id: "o2-academy-birmingham" },
    },
    {
      date: "19/03/2024",
      acts: ["Marika Hackman", "Gia Ford"],
      venue: {
        name: "The Castle & Falcon, Birmingham",
        id: "castle-and-falcon",
      },
    },
    {
      date: "07/05/2024",
      acts: ["Tenacious D", "Dave Hill"],
      venue: { name: "Resorts World Arena, Birmingham", id: "resorts-world-arena-birmingham"},
    },
    {
      date: "29/05/2024",
      acts: ["King Gizzard and the Lizard Wizard", "Grace Cummings"],
      venue: { name: "Wulfrun Hall, Wolverhampton", id: "civic-hall" },
    },
    {
      date: "31/10/2024",
      acts: ["Joywave"],
      venue: { name: "The Bullingdon, Oxford", id: "bullingdon" },
    },
    {
      date: "04/12/2024",
      acts: ["Idles", "Willie J Healey"],
      venue: { name: "O2 Academy, Birmingham", id: "o2-academy-birmingham" },
    },
  ],

  reducers: {},
});

export default counterSlice.reducer;
